import styled from 'styled-components';
import { FormLabel } from '@material-ui/core';

const FormLabelStyled = styled(FormLabel)({
  fontWeight: 550,
  fontSize: 14,
});

export default FormLabelStyled;
